var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", persistent: "" },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event)
            },
          },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", {}, [_vm._v(" Add New Machine")]),
              _c(
                "v-form",
                {
                  staticClass: "pa-5",
                  model: {
                    value: _vm.newMachineFormValid,
                    callback: function ($$v) {
                      _vm.newMachineFormValid = $$v
                    },
                    expression: "newMachineFormValid",
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      label: "Machine Name",
                      rules: _vm.machineNameRules,
                    },
                    model: {
                      value: _vm.newMachineName,
                      callback: function ($$v) {
                        _vm.newMachineName = $$v
                      },
                      expression: "newMachineName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("input", false)
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: !_vm.newMachineFormValid },
                      on: {
                        click: function ($event) {
                          return _vm.createNewMachineCredential()
                        },
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { opacity: 0.5, value: _vm.loading, "z-index": "300" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "42" },
          }),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "primary", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackBar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackBar,
            callback: function ($$v) {
              _vm.snackBar = $$v
            },
            expression: "snackBar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackBarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }